import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api';
import { useMediaAsset } from '~/composables';

interface Props {
  image?: string;
  video?: string;
  videoId?: string;
  title?: string;
  text?: string;
  button?: any;
  features?: any[];
  featuresText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsCarouselSlideMobile',
  props: {
    image: { default: '' },
    video: { default: '' },
    videoId: { default: '' },
    title: { default: '' },
    text: { default: '' },
    button: { default: () => ({}) },
    features: { default: () => [] },
    featuresText: { default: '' }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();

const isPlaying = ref(false);

const playVideo = () => {
  isPlaying.value = true;
};

return { __sfc: true,getAssetUrl, isPlaying, playVideo }
}

})